export const pageview = (GA_MEASUREMENT_ID: string, url: string) => {
  gtag("config", GA_MEASUREMENT_ID, {
    page_path: url,
  });
};

export const track = (name: string, params?: Record<string, any>) => {
  console.log(`【打点】${name}`, params);
  gtag('event', name, params);
}
